import React, { useCallback, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Intro } from './components/Intro';
import { Services } from './components/Services';
import { Bridal } from './components/Bridal';
import { Academy } from './components/Academy';
import { Reviews } from './components/Reviews';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { OpeningCurtain } from './components/OpeningCurtain';
import { SeoHead } from './components/SeoHead';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
import { BookingProvider } from './components/BookingContext';
import { LanguageProvider } from './components/i18n/LanguageContext';
export function App() {
  const [isOpening, setIsOpening] = useState(true);
  const completeOpening = useCallback(() => setIsOpening(false), []);
  return <LanguageProvider data-id="element-0" data-mp="23ti7s3go4sjo">
      <BookingProvider data-id="element-1" data-mp="3ik7k0rkruvvx">
      <div className="w-full min-h-screen bg-warm-white text-dark font-sans antialiased" data-id="element-2" data-mp="3iiweam7rne26">
        <SeoHead data-id="element-3" data-mp="3mkrbpfmkt7ao" />
        <Navbar data-id="element-4" data-mp="3mk852v2dm5by" />
        <main data-id="element-5" data-mp="3mjq2lgp4euvl">
          <Hero data-id="element-6" data-mp="3mj6ibtbzzuee" />
          <Intro data-id="element-7" data-mp="3rc9i4j7dc031" />
          <Services data-id="element-8" data-mp="3rbrcwx2qabiz" />
          <Bridal data-id="element-9" data-mp="3rdkisa5iorpx" />
          <Academy data-id="element-10" data-mp="3rd1a7k1rbfok" />
          <Reviews data-id="element-11" data-mp="3relv0hy9rk98" />
          <Contact data-id="element-12" data-mp="5os92t1uy7l" />
        </main>
        <Footer data-id="element-13" data-mp="4n5i12o8na1" />
        <FloatingWhatsApp data-id="element-14" data-mp="56mnfkhz7n0" />

        <AnimatePresence data-id="element-15" data-mp="2zl3alhpbj03q">
          {isOpening && <OpeningCurtain onComplete={completeOpening} data-id="element-16" data-mp="2zm4wkh7vh708" />}
        </AnimatePresence>
      </div>
      </BookingProvider>
    </LanguageProvider>;
}